import QueryString from "qs";
import { useContext } from "react";
import { useHistory } from "react-router";

import { usePortalRoutes } from "../../../../hooks/usePortalRoutes";
import { RouteFeature } from "../../../../routes/feature";
import { RouteLayout } from "../../../../routes/layout";
import ReportWidgetCard from "../../../ReportWidgetCard/ReportWidgetCard";
import { ReportContext } from "../../ReportContext";

export const ReportNoShowsWidget = ({
  parentRoute,
}: {
  parentRoute: string;
}) => {
  const history = useHistory();
  const { createClubLink } = usePortalRoutes();
  const data = useContext(ReportContext);

  return (
    <ReportWidgetCard
      title="No Shows"
      value={data.events?.noShows?.total.toString() || "0"}
      isLoading={data.isLoading}
      explanation="How many members didn't show up for classes during the selected period."
      variation={data.events?.noShows?.variation}
      onClick={() =>
        history.push({
          pathname: createClubLink(RouteLayout.Staff, RouteFeature.NoShows),
          search: QueryString.stringify({
            startDate: data.startDate,
            endDate: data.endDate,
            backRoute: parentRoute,
          }),
        })
      }
    />
  );
};
